<am-layout-app>
  <am-app-nav [navItems]="navItems" slot="nav">
    <ng-container slot="end">
      <a
        matTooltip="View On Github"
        mat-icon-button
        href="https://github.com/armor/ui"
        target="_blank"
        class="no-external-icon"
      >
        <am-icon name="brand-github"></am-icon>
      </a>
    </ng-container>
  </am-app-nav>

  <ng-container slot="app">
    <router-outlet></router-outlet>
  </ng-container>
</am-layout-app>
